import { DoublePurchaseModule, SwitchProductModule } from '@wix/package-picker-sdk';
import { useCurrentModule } from '../../ModuleProvider';
export const useShouldSubmit = _ref => {
  let {
    shouldOpenDoublePurchaseModal,
    eventAggregator
  } = _ref;
  const module = useCurrentModule();
  const {
    checkDoublePurchase
  } = DoublePurchaseModule.SDK.useCheckDoublePurchase();
  const {
    data: isSwitchFlowData
  } = SwitchProductModule.SDK.switchApiClient.hooks.useIsSwitchFlow({});
  const getShouldSubmit = async () => {
    module.internals.bi.onCheckoutSubmitClick == null || module.internals.bi.onCheckoutSubmitClick({
      eventAggregator
    });
    if (isSwitchFlowData != null && isSwitchFlowData.isSwitchFlow) {
      return true;
    }
    const doublePurchase = await (checkDoublePurchase == null ? void 0 : checkDoublePurchase());
    const status = doublePurchase == null ? void 0 : doublePurchase.status;
    if (status === 'DELIVERED' || status === 'PENDING') {
      shouldOpenDoublePurchaseModal && DoublePurchaseModule.SDK.modalsController.DoublePurchaseModal.show({
        onClose: _ref2 => {
          let {
            reason
          } = _ref2;
          module.internals.bi.onDoublePurchaseModalClose == null || module.internals.bi.onDoublePurchaseModalClose({
            reason
          });
        },
        onConfirm: _ref3 => {
          let {
            reason
          } = _ref3;
          module.internals.bi.onDoublePurchaseModalClick == null || module.internals.bi.onDoublePurchaseModalClick({
            reason
          });
        },
        onLoad: _ref4 => {
          let {
            reason
          } = _ref4;
          module.internals.bi.onDoublePurchaseModalLoad == null || module.internals.bi.onDoublePurchaseModalLoad({
            reason
          });
        }
      });
      return false;
    }
    return true;
  };
  return {
    getShouldSubmit
  };
};
//# sourceMappingURL=useShouldSubmit.js.map